import { createEffect, createSignal, onCleanup } from 'solid-js';
import { createStore } from 'solid-js/store';
import { tokenParamFromSdk } from '@/utils';
import api from '@/services/api';
import { LoginTokenDto } from './login/token';
import { UserAccountDto } from './user/account';
import { token } from './http';
import { CheckinStatusDto } from './checkin/status';
import { createSocket } from 'dgram';

export const [tokenInfo, setTokenInfo] = createStore<LoginTokenDto>(
  token.get() || {
    userId: 0,
    openId: '',
    token: '',
    expired: 0,
  }
);

export const [user, setUser] = createStore<UserAccountDto>({
  fakeUid: '',
  userName: '',
  avatar: '',
  bcBindId: 0,
  tgOpenId: '',
  level: 0,
  totalXp: 0,
  inviteCode: '',
});

export const [checkinStatus, setCheckinStatus] = createStore<CheckinStatusDto>({
  consecutiveDays: 0,
  lastCheckinDate: '',
  todayCheckStatus: true,
});

export const [bcPoints, setBCPoints] = createSignal<number>()

export function usAppLogin() {
  createEffect(async () => {
    if (token.validate()) return;
    const data = await api.login.token(tokenParamFromSdk());
    setTokenInfo(data);
  });

  // async会影响onCleanup
  createEffect(() => {
    if (tokenInfo.token && token.validate()) {
      api.checkin.status().then(setCheckinStatus);

      async function updateAccount() {
        setUser(await api.user.account());
      }

      async function getBcPoints() {
        const result = await api.raffle.getPoint()
        setBCPoints(result.totalBcPoints)
      }

      getBcPoints();
      updateAccount();
      const timer = setInterval(updateAccount, 30 * 1000);
      onCleanup(() => clearInterval(timer));
    }
  });
}
